module.exports = __webpack_public_path__ + "static/media/400W_Hyundai.ac943d6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/400W_Hyundai.jpg
// module id = 1069
// module chunks = 0